module.exports = __webpack_public_path__ + "img/disabled-newCand-assess-icon.4f6cc253.svg";